import { Action, createReducer, on } from '@ngrx/store';

import {
  initialState,
  EntityTiposDocumentoState,
  entityTiposDocumentoAdapter
} from './entity-tipos-documento.state';
import {
  entityTiposDocumentoLoadFailure,
  entityTiposDocumentoLoadRequest,
  entityTiposDocumentoLoadSuccess
} from './entity-tipos-documento.actions';

const reducer = createReducer(
  initialState,
  // load
  on(entityTiposDocumentoLoadRequest, (state) => ({
    ...state,
    isLoading: true,
    error: null
  })),
  on(entityTiposDocumentoLoadFailure, (state, { error }) => ({
    ...state,
    isLoading: false,
    error: error
  })),
  on(entityTiposDocumentoLoadSuccess, (state, { items }) =>
    entityTiposDocumentoAdapter.addMany(items, {
      ...state,
      isLoading: false,
      error: null
    })
  )
);

export function tiposDocumentoReducer(
  state: EntityTiposDocumentoState | undefined,
  action: Action
) {
  return reducer(state, action);
}
